export const log2 = (x) => {
  if (x <= 0) return 0;
  return Math.ceil(Math.log2(x));
};
const dv = (data) => new DataView(data.buffer, data.byteOffset, data.byteLength);
export const readInt8 = (data, offset) => dv(data).getInt8(offset);
export const readUint16 = (data, offset) => dv(data).getUint16(offset, false);
export const readUint32 = (data, offset) => dv(data).getUint32(offset, false);
